var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('div',{staticClass:"heade"},[_c('top-head')],1),_c('div',{staticClass:"content"},[_c('div',{staticClass:"left-menu"},[_c('left-menu')],1),_c('div',{staticClass:"right-content"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }